import { Component, Input } from '@angular/core';
import { PopoverService } from '@services/popover/popover.service';

interface IParticipant {
  name: string;
  avatarUrl?: string;
}

@Component({
  selector: 'app-participant-view',
  templateUrl: './participant-view.component.html',
  styleUrls: ['./participant-view.component.scss'],
})
export class ParticipantViewComponent {

  @Input() participants: IParticipant[] = [];

  constructor(private popoverService: PopoverService) {
  }

  public async close(): Promise<void> {
    await this.popoverService.safeDismiss();
  }

}
